import React, { Component } from 'react';
import { connect } from 'react-redux';
import { StyleRoot } from 'radium';
import moment from 'moment';
import Rollbar from 'rollbar';
import ReactGA from 'react-ga';
import { string, shape, object } from 'prop-types';
import { StylesProvider } from '@material-ui/styles';
import JssProvider from 'react-jss/lib/JssProvider';
import { create } from 'jss';
import jssPreset from 'jss-preset-default';
import 'moment/locale/es';
import { loadRecaptchaScript, disableReactDevTools } from '@widergy/web-utils/lib/config';
import Polling from '@widergy/polling-handling';
import { EnergyThemeProvider, AlertHandler, UTAlert } from '@widergy/energy-ui';

import api, { apiSetup } from 'config/api';
import { actionCreators as authActions } from 'redux/authHandlers';
import { pollingFailureCallback } from 'utils/pollingUtils';
import { appConfig } from 'config/customization';
import { PUBLIC_ROUTES } from 'constants/routes';

import Routes from './components/Routes';
import BaseStyles from './styles';
import UTAlertModal from './components/UTAlertModal';
import { energyUITheme } from './energyUITheme';

moment.locale('es');

const jss = create(jssPreset());

jss.options.insertionPoint = document.getElementById('jss-insertion-point');

class App extends Component {
  constructor(props) {
    super(props);
    Rollbar.init({
      accessToken: process.env.REACT_APP_ROLLBAR_TOKEN,
      captureUncaught: true,
      captureUnhandledRejections: true,
      hostWhiteList: ['edensa.com.ar', 'infoedes.com', 'edelap.com.ar', 'widergy.com', 'widergydev.com'],
      payload: {
        environment: process.env.REACT_APP_UTILITY_NAME
      }
    });
    window.Rollbar = Rollbar;
    this.state = {};
  }

  componentDidMount() {
    apiSetup();
    AlertHandler.init({ setState: this.handleUpdateAlert });
    Polling.init(
      `${process.env.REACT_APP_API_BASE_URL}async_request/jobs/`,
      api.monitors,
      pollingFailureCallback
    );
    ReactGA.set({ userId: this.props.publicUserId });
    const isPublicRoute = PUBLIC_ROUTES.includes(this.props.location.pathname);
    if (!isPublicRoute) this.props.dispatch(authActions.setEnteredUrl(this.props.location));
    this.props.dispatch(authActions.init(isPublicRoute));
    loadRecaptchaScript();
    disableReactDevTools();
  }

  handleUpdateAlert = alert => this.setState({ alert });

  render() {
    return (
      <JssProvider jss={jss}>
        <StylesProvider injectFirst>
          <StyleRoot>
            <EnergyThemeProvider theme={energyUITheme}>
              <UTAlert withoutIcon={appConfig.alerts.withoutIcon} content={this.state.alert} />
              <UTAlertModal />
              {BaseStyles}
              <Routes />
            </EnergyThemeProvider>
          </StyleRoot>
        </StylesProvider>
      </JssProvider>
    );
  }
}

App.propTypes = {
  publicUserId: string,
  location: shape({
    pathname: string.isRequired,
    state: object,
    search: string
  })
};

const mapStateToProps = store => ({
  publicUserId: store.auth.publicUserId,
  location: store.router.location
});

export default connect(mapStateToProps)(App);
